import React from 'react';
import { Radio } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';

export const RadioField = ({ name, label, options = [], disabled, required }: any) => {
  const { setFieldValue, values } = useFormikContext<any>();
  return (

    <FormFieldWrapper name={name} label={label} required={required}>
      <Radio.Group
        onChange={e => setFieldValue(name, e.target.value)}
        value={values[name]}
        disabled={disabled}
      >
        {options.map((opt: any) => (
          <Radio key={opt.value} value={opt.value}>
            {opt.label}
          </Radio>
        ))}
      </Radio.Group>
    </FormFieldWrapper>
  );
};
